import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from 'src/components/Elements/Button'

const QrButton = ({ event }) => {
  const navigate = useNavigate()
  const eventId = event?.id
  const text = event?.is_attended ? 'QR Code/Scanner' : 'Check-In'

  const onClick = (e) => {
    e.stopPropagation()
    navigate(`/programs/${eventId}/qr-code`)
  }

  return (
    <Button
      color="darkBase"
      onClick={onClick}
      label={text}
      size="med"
      disabled={false}
      data-testid="qrButton"
    />
  )
}

export default QrButton
